import { mobileBreakpoints } from '../../../../constants/breakpoints/mobileBreakpoints';

export const GRID_COLUMNS_PIN_BREAKPOINTS = mobileBreakpoints;
